<template>
  <li 
    class="activity-result__stack-list__item"
    :class="{ active, selected }" />
</template>

<script>
export default {
  props: {
    date: {
      type: Date,
      required: true
    },
    dailyWorkList: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    active() {
      return this.dailyWorkList.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-result__stack-list__item {
  list-style: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid $grey10;
  margin-right: 2px;
  margin-bottom: 2px;

  &.active {
    border: none;
    background-color: $l-blue;
  }

  &.active.selected {
    background-color: $pink;
  }
}
</style>